import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SITE, LEGAL, waLink } from "@/config/site";

const SECTIONS = [
  {
    title: "Titolare del trattamento",
    body: `Il titolare del trattamento dei dati è ${LEGAL.company}, con sede legale in ${LEGAL.legalAddress}, P.IVA ${LEGAL.vat}. Farma Store è un marchio registrato di ${LEGAL.company}. La parafarmacia ti accoglie in ${SITE.address}. Per qualsiasi richiesta relativa alla privacy puoi contattarci tramite WhatsApp o direttamente in negozio.`,
  },
  {
    title: "Dati che raccogliamo",
    body: "Questo sito non prevede registrazione, account o moduli di contatto. Quando ci scrivi su WhatsApp, la conversazione avviene tramite la piattaforma WhatsApp (Meta) secondo la sua informativa privacy. I dati che ci fornisci volontariamente in chat (nome, richiesta, eventuali informazioni sui tuoi bisogni) sono utilizzati solo per risponderti.",
  },
  {
    title: "Finalità e base giuridica",
    body: "I dati forniti volontariamente sono trattati esclusivamente per rispondere alle tue richieste di informazioni su prodotti, servizi, promozioni e appuntamenti in parafarmacia. Non vengono utilizzati per finalità di marketing senza il tuo consenso e non vengono ceduti a terzi.",
  },
  {
    title: "Cookie",
    body: "Il sito non utilizza cookie di profilazione propri. Sono presenti servizi di terze parti che possono installare cookie tecnici o di misurazione: Google Maps (mappa nella sezione Contatti), Google Fonts e Fontshare (caratteri tipografici). Puoi gestire o eliminare i cookie dalle impostazioni del tuo browser.",
  },
  {
    title: "I tuoi diritti",
    body: "In qualità di interessato puoi esercitare in qualsiasi momento i diritti previsti dal GDPR (artt. 15–22): accesso, rettifica, cancellazione, limitazione e opposizione al trattamento. Per esercitarli è sufficiente contattarci in negozio o tramite WhatsApp.",
  },
];

export default function Privacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Privacy e Cookie Policy | Farma Store";
    return () => {
      document.title = "Farma Store | Parafarmacia, Dermocosmesi e Benessere a Castrocielo";
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#faf8f5] text-[#1c1d1f]" data-testid="privacy-page">
      <header className="border-b border-black/[0.06] bg-white/85 backdrop-blur-xl">
        <div className="container-x flex h-[72px] items-center justify-between">
          <Link to="/" data-testid="privacy-logo" aria-label="Farma Store — torna alla home">
            <img src="/logo.webp" alt="Farma Store — Parafarmacia e Servizi" className="h-8 w-auto sm:h-9" width="2000" height="343" />
          </Link>
          <Link
            to="/"
            data-testid="privacy-back-link"
            className="btn border border-black/15 bg-white px-5 py-2.5 text-sm text-[#1c1d1f] hover:border-black/30"
          >
            <ArrowLeft className="h-4 w-4" />
            Torna alla home
          </Link>
        </div>
      </header>

      <main className="container-x py-14 sm:py-20">
        <p className="eyebrow">Documento legale</p>
        <h1 className="h-display mt-4 max-w-2xl text-3xl leading-[1.08] sm:text-4xl lg:text-5xl">
          Privacy e Cookie Policy
        </h1>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-[#575a61]">
          Informativa resa ai sensi del Regolamento (UE) 2016/679 (GDPR) a chi visita questo sito.
        </p>

        <div className="mt-12 max-w-3xl space-y-5">
          {SECTIONS.map((s, i) => (
            <section key={s.title} data-testid={`privacy-section-${i + 1}`} className="card p-7 sm:p-8">
              <h2 className="font-display text-lg font-bold tracking-tight text-[#1c1d1f] sm:text-xl">
                {i + 1}. {s.title}
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-[#575a61] sm:text-base">{s.body}</p>
            </section>
          ))}
        </div>

        <p className="mt-10 text-sm text-[#888c95]">
          Ultimo aggiornamento: luglio 2026 · {SITE.name}, {SITE.address} ·{" "}
          <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="privacy-whatsapp-link" className="font-bold text-[#0050e0] hover:underline">
            Contattaci su WhatsApp
          </a>
        </p>
      </main>
    </div>
  );
}
